export default __webpack_public_path__ + "static/media/img-gt-mode-gt-bg-na_en@2x.b9176605.jpg";